export enum USER_STATUS {
  REGISTERED = "registered",
  NOT_REGISTERED = "not_registered",
  INVITATION_SENT = "invitation_sent",
  EXPIRED_INVITATION = "expired_invitation",
}

export enum BALANCE_DELTA_PERIOD {
  Last10Days = "last10Days",
  Last30Days = "last30Days",
  Last90Days = "last90Days",
  Last365Days = "last365Days",
}
